<div class="circle-parent" *ngIf="color" [ngClass]="setClasses()"
     (click)="selectColor($event)" [style.background-color]="color.colorHex">
  <div *ngIf="color.selected" class="circle-child"></div>
</div>
